import React from 'react';
import LinkSessionStatus from '../_shared/LinkSessionStatus';

function PatientScheduleForm({ status, onRetryPress }) {
	return (
		<LinkSessionStatus
			status={status}
			expiredDescription="Solicite um novo link para realizar o seu agendamento."
			onRetryPress={onRetryPress}
		/>
	);
}

export default PatientScheduleForm;
